import React,{ FunctionComponent, useState, FormEvent,useRef} from 'react'
import PropTypes, { InferProps } from 'prop-types'
import { Button, Nav, Navbar, Container, Form, FormControl, FormLabel, Row, Col, FormGroup,Card } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import * as d3 from 'd3'
import { SankeyDataPropTypes }  from 'open-sankey/dist/types'
import ReCAPTCHA from "react-google-recaptcha"
import { registerNewLicenseOpenSankeyPlus, registerNewLicenseSankeySuite } from './LicenseFunctions'

// Check Licence and register account if everything is Ok
async function userSignUp(
  email: string,
  password: string,
  firstname: string,
  lastname: string,
  license_opensankeyplus: string,
  license_sankeysuite: string,
  navigate: (s:string)=>string
) {
  d3.select('.LogError').selectAll('*').remove()
  // Enregistrement dans la base de donnée utilisateur
  fetch(window.location.origin+'/auth/signup', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      email: email,
      password: password,
      firstname: firstname,
      lastname: lastname,
      license_opensankeyplus: license_opensankeyplus,
      license_sankeysuite: license_sankeysuite
    })
  }).then(response => {
    // console.log('POST signup : SUCCESS', response.json())
    // Enregistrement licence OpenSankey+
    if (license_opensankeyplus !== '') {
      registerNewLicenseOpenSankeyPlus(license_opensankeyplus)
    }
    // Enregistrement licence SankeySuite
    if (license_sankeysuite !== '') {
      registerNewLicenseSankeySuite(license_sankeysuite)
    }
    // On retourne vers la page de login
    d3.select('.LogError').html('<p style="color:green">Information saved <br> You will be redirected to the login page in a moment</p>')
    setTimeout(()=>{
      navigate("/login")
    },8000)
  }).catch(error =>
    console.log('POST signup : ERROR', error)
  )
}

// UI : License checkin
const LicenseCheckInPropTypes = {
  navbar_logo: PropTypes.string.isRequired,
  navbar_logo_width: PropTypes.number,
  navbar_app_version: PropTypes.string.isRequired,
  setToken: PropTypes.func.isRequired,
  useNavigate: PropTypes.func.isRequired,
  data: PropTypes.shape(SankeyDataPropTypes).isRequired,
  set_data:PropTypes.func.isRequired
}
type LicenseCheckInTypes = InferProps<typeof LicenseCheckInPropTypes>

const LicenseCheckIn:FunctionComponent<LicenseCheckInTypes>=({
  navbar_logo, navbar_logo_width, navbar_app_version,
  setToken,
  useNavigate,data,set_data})=>
{

  // License registrering informations
  const [userName, setUserName] = useState('')
  const [password, setPassword] = useState('')
  const [firstname, setUserFirstName] = useState('')
  const [lastname, setUserLastName] = useState('')
  const [license_opensankeyplus, setUserLicenseOpenSankeyPlus] = useState('')
  const [license_sankeysuite, setUserLicenseSankeySuite] = useState('')
  const captchaRef=useRef<ReCAPTCHA>(null)
  const [captcha_passed,set_captcha_passed]=useState(false)
  // Initialise traduction function
  const {t} = useTranslation()
  // Initialise navigation function
  const navigate = useNavigate()

  // Handler : License registrering
  const handleSubmit = async (e:FormEvent<HTMLFormElement>) => {
    e.preventDefault()
   
    

    if(captcha_passed){
      await userSignUp(
        userName,
        password,
        firstname,
        lastname,
        license_opensankeyplus,
        license_sankeysuite,
        navigate
      )
      // Enregistre les nom et prenom de l'utilisateurs dans un cookie
      const cook ='info_log={"'+userName+'":{"lastname":"'+lastname+'","firstname":"'+firstname+'"}}'
      const expiration=1000*60*60*24*-3 //le temps pour que le cookie expire en ms (ms*secondes*minutes*heures*jours)
      const tmp=cook+';path=/;+expires='+new Date(Date.now()+expiration).toUTCString()
      document.cookie=tmp
      setToken(false)
    }else{
      d3.select('.LogError').html('<p style="color:red">Error : Captcha invalid</p>')
    }
    
  }

  return(
    <div>
      <Navbar className='bg-light navbar-Account' fixed='top' style={{ 'display': 'block' }} >
        <Container className='MenuNavigation'>
          <Navbar.Brand href="/"><img src={navbar_logo} width={navbar_logo_width ? navbar_logo_width : 200} alt="logo"/> {navbar_app_version} </Navbar.Brand>
          <Nav>
            <Nav.Item>
              <Button variant='light' onClick={()=>{navigate('/')
                set_data({...data})
              }}>{t('UserPages.to_app')}</Button>
            </Nav.Item>
          </Nav>
        </Container>
      </Navbar>

      <div className="license-check-in-wrapper">
        <Card style={{'marginTop':'175px'}}>
          <Card.Header style={{'textAlign':'center'}}>{t('Register.reg_win')}</Card.Header>
          <Card.Body>
            <Form onSubmit={handleSubmit}>
              <FormGroup as={Row}>
                <Col>
                  <FormLabel>{t('UserPages.id')}</FormLabel>
                  <FormControl type="text" onChange={e => setUserName(e.target.value)}/>
                </Col>
              </FormGroup>
              <FormGroup as={Row}>
                <Col>
                  <FormLabel>{t('UserPages.mdp')}</FormLabel>
                  <FormControl type="password"  onChange={e => setPassword(e.target.value)}/>
                </Col>
              </FormGroup>
              <FormGroup as={Row}>
                <Col>
                  <FormLabel>{t('UserPages.pnom')}</FormLabel>
                  <FormControl type="text" onChange={e => setUserFirstName(e.target.value)}/>
                </Col>
              </FormGroup>
              <FormGroup as={Row}>
                <Col>
                  <FormLabel>{t('UserPages.nom')}</FormLabel>
                  <FormControl type="text" onChange={e => setUserLastName(e.target.value)}/>
                </Col>
              </FormGroup>
              <FormGroup as={Row}>
                <Col>
                  <FormLabel>{t('Register.OS+_lic')}</FormLabel>
                  <FormControl type="text" onChange={e => setUserLicenseOpenSankeyPlus(e.target.value)}/>
                  <div style={{'textAlign':'right'}}>
                    <Col>
                      <Button href="https://terriflux.com/downloads/open-sankey-plus/"
                      target="_blank" rel="noopener noreferrer">
                        {t('Register.OS+_link')}
                      </Button>
                    </Col>
                  </div>
                </Col>
              </FormGroup>
              <FormGroup as={Row}>
                <Col>
                  <FormLabel>{t('Register.SS_lic')}</FormLabel>
                  <FormControl type="text" onChange={e => setUserLicenseSankeySuite(e.target.value)}/>
                  <div style={{'textAlign':'right'}}>
                    <Col>
                      <Button
                      href="https://terriflux.com/downloads/sankey-suite/"
                      target="_blank" rel="noopener noreferrer">
                        {t('Register.SS_link')}
                      </Button>
                    </Col>
                  </div>
                </Col>
                </FormGroup>
                <FormGroup as={Row}>
                <Col>
                  <ReCAPTCHA
                    sitekey="6Les5JwmAAAAAOi3F8DLW4Z1aoqVMDBC9WpN1KFe"
                    ref={captchaRef}
                    onChange={()=>{
                      const token_captcha=captchaRef.current?.getValue()
                      const fetchData = {
                        method: 'POST',
                        headers: {
                          'Content-Type': 'application/json'
                          },
                        body: JSON.stringify({
                          'token': token_captcha
                        })
                      }
                  
                      const path = window.location.origin
                      const url = path + '/auth/check_captcha'
                      fetch(url, fetchData).then(
                        r => r.json().then(t=>{
                          set_captcha_passed(t['success'])
                        })
                        ).catch(e=>set_captcha_passed(false))
                        
                    }}
                />
                </Col>
              </FormGroup>
              
              <div style={{'textAlign':'center', 'marginTop':'15px'}}>
                <button
                  className='btn-signup'
                  type="submit"
                  style={{'textAlign':'left', 'marginRight':'5px'}}>
                    {t('Register.reg')}
                </button>
                <button
                  className='btn-to-login'
                  style={{'textAlign':'right', 'marginLeft':'5px'}}
                  onClick={()=>navigate('/login')}>
                    {t('UserPages.to_con')}
                </button>
              </div>
              <div className='LogError' style={{'color':'red'}}></div>
            </Form>
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}


LicenseCheckIn.propTypes = LicenseCheckInPropTypes

export default LicenseCheckIn
